"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * USCIS Verifications Identity Service
 * An [Oauth 2.0](https://tools.ietf.org/html/rfc6749) compliant API which wraps the [identity providers](https://maestro.dhs.gov/confluence/display/VERST/Identity+Providers) used in the USCIS Verifications ecosystem.
 *
 * The version of the OpenAPI document: 2.4.6
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadRequestErrorToJSON = exports.BadRequestErrorFromJSONTyped = exports.BadRequestErrorFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function BadRequestErrorFromJSON(json) {
    return BadRequestErrorFromJSONTyped(json, false);
}
exports.BadRequestErrorFromJSON = BadRequestErrorFromJSON;
function BadRequestErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': !runtime_1.exists(json, 'code') ? undefined : _1.ValidationErrorCodeFromJSON(json['code']),
        'message': json['message'],
        'field': json['field'],
        'value': json['value'],
    };
}
exports.BadRequestErrorFromJSONTyped = BadRequestErrorFromJSONTyped;
function BadRequestErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': _1.ValidationErrorCodeToJSON(value.code),
        'message': value.message,
        'field': value.field,
        'value': value.value,
    };
}
exports.BadRequestErrorToJSON = BadRequestErrorToJSON;
